// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1016":"b37f61df","3407":"d19b4319","5601":"3e4930b3","7799":"dcb62ace"}[chunkId] + ".chunk.css";
};